import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass } from '../../../helper/classes'
import Snake from 'react-snake-game'

function SnakeAddOn () {
  return (
    <div css={css`position: absolute; width: 100%; height: 100%;`}><Snake sound /></div>
  )
}

const SnakeAddOnBoxClass = new BoxClass(SnakeAddOn, 'Snake', null, 3, { order: 20 })

export default SnakeAddOnBoxClass
